import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-reset-pin-component',
    templateUrl: './reset-pin-component.component.html',
    styleUrls: ['./reset-pin-component.component.scss'],
    standalone: false
})
export class ResetPinComponentComponent implements OnInit {
  constructor(private _appService: AppService) {}

  ngOnInit(): void {
    this._appService.setLeftMenuVisibilityStatus(false);
  }
  onSave() {}
}
